import { IContactUs } from '../_models/commonInterface'
import { post } from './apiServices'

const contactUs = async (data: IContactUs) => {
  const response = post('/contact-us', data)
  return response
}

const getPricingPlans = async () => {
  // const response = await get('/pricing-plans')
  // return response
  return {
    status: 'success',
    message: 'This is not a subscription-based application.',
    data: {
      // eslint-disable-next-line camelcase
      is_subscription_based: false,
    },
  } as any
}
const publicPagesService = {
  contactUs,
  getPricingPlans,
}

export default publicPagesService
